import { asyncPreactWidget } from '../../utils/async-preact-widget';
import { asyncModule } from '../../utils/async-module';
import * as JSModules from '../../components/modules';
import * as preactWidgets from '../../preact/widgets';
import { hasLmpTab } from '../../utils/aem-utils';

export const asyncBannerNewsletter = () => {
  const $elements = document.querySelectorAll('.j-banner-newsletter');
  if ($elements.length) {
    const { start, getInit, error } = asyncModule(JSModules.bannerNewsletterModule);
    start();
    import('../../components/banner-newsletter/banner-newsletter').then(getInit($elements)).catch(error);
  }
};

export const asyncNewsletterSignup = () => {
  const { isOnPage, start, hydrate, error } = asyncPreactWidget(preactWidgets.newsletterSignup);
  if (isOnPage()) {
    start();
    import(`../../preact/widgets/newsletter-signup`).then(hydrate).catch(error);
  }
};
